export default __webpack_public_path__ + "static/media/NMT_Logo_by_thomas.70b95f65.png";